import { useTranslation } from 'react-i18next';
import { useClientQueries } from '@zenstackhq/tanstack-query/react';
import { schema } from '../__generated__/schema-lite';
import { AdminAgentDashboard } from '../components/AdminAgentDashboard';
import { SpecialistDashboard } from '../components/SpecialistDashboard';
import { SuperdocHome } from '../components/SuperdocHome';
import { AppLoader } from '../components/AppLoader';

/** Landing page. Admins get the call dashboard; specialists get their
 *  calendar dashboard; SUPERDOC gets a light oversight home; everyone else
 *  gets a plain placeholder. */
export default function HomePage() {
  const { t } = useTranslation();
  const crud = useClientQueries(schema);
  const { data: me } = crud.$procs.me.useQuery();
  const role = (me as { role?: string } | undefined)?.role;

  // Until `me` resolves the role is unknown; show a loader rather than briefly
  // flashing the generic welcome placeholder before the role dashboard mounts.
  if (me === undefined) return <AppLoader />;

  if (role === 'ADMIN') return <AdminAgentDashboard />;
  if (role === 'SPECIALIST') return <SpecialistDashboard />;
  if (role === 'SUPERDOC') return <SuperdocHome />;

  return (
    <div className="px-4 py-8 sm:py-12 max-w-3xl mx-auto space-y-2">
      <h1 className="text-2xl font-semibold">{t('dashboard.welcome')}</h1>
      <p className="text-sm text-muted-foreground">{t('dashboard.welcomeSub')}</p>
    </div>
  );
}
